import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PaySlipExporter  {
    _originalTypeClassName = "zERP.BO.PaySlipExporter";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PaySlipExporter.translate = translateService;
}
this.PaySlipExporterKey = null;
this._key = this.PaySlipExporterKey = 0; 
}

static translate: TranslateService;
_key: any;
private _PaySlipExporterKey:any;
get PaySlipExporterKey(): any {
    return this._PaySlipExporterKey;
  }
set PaySlipExporterKey(value: any) {
    this._PaySlipExporterKey = value;
    this._key = value;
  }

static GetCollectionVariables(payroll: any,lst_salaries: any): any{console.info("Employee: " + payroll?.Employee?.Fullname);
let empty = [];
let vars = new window['Map']();
let excludedSalariesIds = lst_salaries?.linq?.select((s) => s?.Id)?.toArray();
let basicSalariesChildren = [];
basicSalariesChildren?.add({
Name: "name",Description: "Όνομα",}
);
basicSalariesChildren?.add({
Name: "amount",Description: "Ποσό",Type: Domain.ExcelExporterVariableType.Currency,}
);
vars.set({
Name: "BASIC_SALARIES",Description: "Βασικές Αποδοχές",IsCollection: true,Children: basicSalariesChildren,}
, Joove.Common.cast(payroll?.Salaries?.linq?.where((s) => s?.Salary?.RuleType == Domain.SalaryRuleType.Basic && CLMS.Framework.Number.GreaterThan(() => s.Amount, () => 0) && !((excludedSalariesIds?.linq?.contains(s?.Salary?.Id))))?.toArray(), "System.Collections.List"));
let mainSalariesChildren = [];
mainSalariesChildren?.add({
Name: "name",Description: "Όνομα",}
);
mainSalariesChildren?.add({
Name: "amount",Description: "Ποσό",Type: Domain.ExcelExporterVariableType.Currency,}
);
vars.set({
Name: "MAIN_SALARIES",Description: "Κύριες Αποδοχές",IsCollection: true,Children: mainSalariesChildren,}
, Joove.Common.cast(payroll?.Salaries?.linq?.where((s) => s?.Salary?.RuleType == Domain.SalaryRuleType.Main && CLMS.Framework.Number.GreaterThan(() => s.Amount, () => 0) && !((excludedSalariesIds?.linq?.contains(s?.Salary?.Id))))?.toArray(), "System.Collections.List"));
let otherSalariesChildren = [];
otherSalariesChildren?.add({
Name: "name",Description: "Όνομα",}
);
otherSalariesChildren?.add({
Name: "amount",Description: "Ποσό",Type: Domain.ExcelExporterVariableType.Currency,}
);
otherSalariesChildren?.add({
Name: "hours",Description: "Ώρες",Type: Domain.ExcelExporterVariableType.Hours,}
);
vars.set({
Name: "OTHER_SALARIES",Description: "Λοιπές Αποδοχές",IsCollection: true,Children: otherSalariesChildren,}
, Joove.Common.cast(payroll?.Salaries?.linq?.where((s) => s?.Salary?.RuleType == Domain.SalaryRuleType.Other && CLMS.Framework.Number.GreaterThan(() => s.Amount, () => 0) && !((excludedSalariesIds?.linq?.contains(s?.Salary?.Id))))?.toArray(), "System.Collections.List"));
let contributionsChildren = [];
contributionsChildren?.add({
Name: "description",Description: "Περιγραφή",}
);
contributionsChildren?.add({
Name: "amount",Description: "Ποσό",Type: Domain.ExcelExporterVariableType.Currency,}
);
contributionsChildren?.add({
Name: "employeeramount",Description: "Ποσό Εργοδότη",Type: Domain.ExcelExporterVariableType.Currency,}
);
vars.set({
Name: "CONTRIBUTIONS",Description: "Εισφορές",IsCollection: true,Children: contributionsChildren,}
, Joove.Common.cast(payroll?.Contributions, "System.Collections.List"));
vars.set({
Name: "CONTRIBUTIONS_GROUPED",Description: "Εισφορές ανά ταμείο",IsCollection: true,Children: contributionsChildren,}
, Joove.Common.cast(Domain.PaySlipExporter.GroupContributions(payroll?.Contributions), "System.Collections.List"));
let loansChildren = [];
loansChildren?.add({
Name: "description",Description: "Περιγραφή",}
);
loansChildren?.add({
Name: "amount",Description: "Ποσό",Type: Domain.ExcelExporterVariableType.Currency,}
);
if (!(payroll?.LoanInstalments?.linq?.any())) {let emptyLoans = [];vars.set({
Name: "LOANS",Description: "Δάνεια",IsCollection: true,Children: loansChildren,}
, emptyLoans);}else {vars.set({
Name: "LOANS",Description: "Δάνεια",IsCollection: true,Children: loansChildren,}
, Joove.Common.cast(payroll?.LoanInstalments, "System.Collections.List"));}
let deductionsChildren = [];
deductionsChildren?.add({
Name: "description",Description: "Περιγραφή",}
);
deductionsChildren?.add({
Name: "amount",Description: "Ποσό",Type: Domain.ExcelExporterVariableType.Currency,}
);
vars.set({
Name: "DEDUCTIONS",Description: "Κρατήσεις",IsCollection: true,Children: deductionsChildren,}
, Joove.Common.cast(payroll?.Deductions?.linq?.where((l) => CLMS.Framework.Number.GreaterThan(() => l.EmployeeAmount, () => 0))?.toArray(), "System.Collections.List"));
return vars;
}
static GroupContributions(contributions: any): any{let dtos = [];
let contributionsDictionary = new window['Map']();
for (let _iconDetail = 0; _iconDetail < (contributions == null ? 0 : contributions.length); _iconDetail++) {let conDetail = contributions[_iconDetail];let tmpDetails = [];if (!(contributionsDictionary.has(conDetail?.Rule?.Name))) {tmpDetails?.add(conDetail);contributionsDictionary.set(conDetail?.Rule?.Name, tmpDetails);continue;}tmpDetails = contributionsDictionary.get(conDetail?.Rule?.Name);tmpDetails?.add(conDetail);contributionsDictionary.set(conDetail?.Rule?.Name, tmpDetails);}
for (let _ikey = 0; _ikey < (Array['from'](contributionsDictionary.keys()) == null ? 0 : Array['from'](contributionsDictionary.keys()).length); _ikey++) {let key = Array['from'](contributionsDictionary.keys())[_ikey];let newDTO = new Domain.PayrollContributionGroupingDTO();let values = contributionsDictionary.get(key);newDTO.Name = key;newDTO.Amount = values?.linq?.sum((l) => l?.EmployeeContribution);newDTO.EmployeerAmount = values?.linq?.sum((l) => l?.EmployerContribution);dtos?.add(newDTO);}
return dtos;
}
static ResolveCollectionItem(collectionName: any,varName: any,item: any): any{let resp;
resp.Value = "";
if (collectionName == "BASIC_SALARIES") {let basic = Joove.Common.cast(item, "Domain.PayrollSalaryDetail");switch (varName?.toLowerCase()) {case "name":
{
resp.Value = basic?.Salary?.Name;return resp;}
case "amount":
{
resp.Value = basic?.Amount;resp.VType = Domain.ExcelExporterVariableType.Currency;return resp;}
}}
if (collectionName == "MAIN_SALARIES") {let main = Joove.Common.cast(item, "Domain.PayrollSalaryDetail");switch (varName?.toLowerCase()) {case "name":
{
resp.Value = main?.Salary?.Name;return resp;}
case "amount":
{
resp.Value = main?.Amount;resp.VType = Domain.ExcelExporterVariableType.Currency;return resp;}
}}else if (collectionName == "OTHER_SALARIES") {let other = Joove.Common.cast(item, "Domain.PayrollSalaryDetail");switch (varName?.toLowerCase()) {case "name":
{
resp.Value = other?.Salary?.Name;return resp;}
case "amount":
{
resp.Value = other?.Amount;resp.VType = Domain.ExcelExporterVariableType.Currency;return resp;}
case "hours":
{
resp.Value = other?.OvertimeHours;resp.VType = Domain.ExcelExporterVariableType.Hours;return resp;}
}}else if (collectionName == "CONTRIBUTIONS") {let contribution = Joove.Common.cast(item, "Domain.PayrollContributionDetail");switch (varName?.toLowerCase()) {case "description":
{
resp.Value = contribution?.Rule?.Name;return resp;}
case "amount":
{
resp.Value = contribution?.EmployeeContribution;resp.VType = Domain.ExcelExporterVariableType.Currency;return resp;}
}}else if (collectionName == "CONTRIBUTIONS_GROUPED") {let contribution = Joove.Common.cast(item, "Domain.PayrollContributionGroupingDTO");switch (varName?.toLowerCase()) {case "name":
{
resp.Value = contribution?.Name;return resp;}
case "amount":
{
resp.Value = contribution?.Amount;resp.VType = Domain.ExcelExporterVariableType.Currency;return resp;}
case "employeeramount":
{
resp.Value = contribution?.EmployeerAmount;resp.VType = Domain.ExcelExporterVariableType.Currency;return resp;}
}}else if (collectionName == "LOANS") {let loan = Joove.Common.cast(item, "Domain.EmployeeSalaryLoanInstalment");switch (varName?.toLowerCase()) {case "description":
{
resp.Value = loan?.EmployeeSalaryLoan?.Type?.Name;return resp;}
case "payment":
{
resp.Value = loan?.Amount;resp.VType = Domain.ExcelExporterVariableType.Currency;return resp;}
}}else if (collectionName == "DEDUCTIONS") {let deduction = Joove.Common.cast(item, "Domain.PayrollDeductionDetail");switch (varName?.toLowerCase()) {case "description":
{
resp.Value = deduction?.Rule?.Name;return resp;}
case "amount":
{
resp.Value = deduction?.EmployeeAmount;resp.VType = Domain.ExcelExporterVariableType.Currency;return resp;}
}}
return resp;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.PaySlipExporterKey == null || $this.PaySlipExporterKey == 0;
            }


}